export enum StockLedgerEntryType {
  SALE = "SALE",
  RETURN = "RETURN",
  INTAKE = "INTAKE",
  ADJUSTMENT = "ADJUSTMENT",
  TRANSFER_OUT = "TRANSFER_OUT",
  TRANSFER_IN = "TRANSFER_IN",
  OPENING = "OPENING",
}
